var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('token-stepup',{staticClass:"isotope-step-up-category--token",attrs:{"stepUpCategory":_vm.stepUpCategory,"tokenLength":8}})}
var staticRenderFns = []

export { render, staticRenderFns }